export default "__VITE_PUBLIC_ASSET__f04f243f__"